import { AxiosResponse } from 'axios'

import { ShiftAnswer } from 'types/shiftAnswer'

import { _axios } from './axios'

const SHIFT_QUESTIONNAIRE_ANSWER = '/shift_questionnaire_answers'

export const shiftQuestionnaireAnswerApi = () => {
  const create = async (
    token: string,
    shiftQuestionnaireId: string,
    answers: ShiftAnswer[],
  ): Promise<AxiosResponse<void>> => {
    return await _axios().post(SHIFT_QUESTIONNAIRE_ANSWER, {
      token,
      shiftQuestionnaireId,
      answers,
    })
  }

  return {
    create,
  }
}
